import { configureStore } from 'app/Store/configureStore'

import history from './history'
const { store, persistor } = configureStore(history)

export { store, persistor, history }
